// Used through the app to provide routes
// to navigate to

// APP ROUTES
export const kInternalRoutes = {
    // ---- Meta navigation
    authentication: "/authentification",
    home: "/",
    // ---- App navigation
    courses: "/cours-et-exercices",
    brevet: "/brevet",
    glossary: "/glossaire",
    games: "/jeux",
    // ---- Cross app
    levelA: '/savoir-faire/:slug',
    flash: "/flash",
    exerciser: "/exerciseur",
    // ---- Games
    mentalLevelOneGame: "/jeux/calcul-mental/tables-multiplication",
    relativeLevelOneGame: "/jeux/relatifs/addition-relatifs",
    relativeLevelTwoGame: "/jeux/relatifs/soustraire-relatifs",
    // ---- Side navigation
    about: "/a-propos",
    legals: "/mentions-legales",
    privacy: "/confidentialite",
    support: "/soutenir",
    themes: "/programme",
    // ---- Off limit navigation
    previewQuestion: "/preview/question/:id",
    previewExerciser: "/preview/exerciser/:identifier",
    graph: "/graph",
}